const Loading = ({ children, light }) => {
  return <div className={`Loading ${light ? `light` : ``}`}>{children}</div>;
};

Loading.defaultProps = {
  children: null,
};

export default Loading;
